import "../style/DonutCardSkeleton.css";
export default function DonutCardSkeleton() {
  return (
    <div className="ec-chart-skeleton-card">

      <div className="ec-chart-skeleton-donut">
        <div className="ec-chart-skeleton-ring"></div>
        <div className="ec-chart-skeleton-center"></div>
      </div>

      <div className="ec-chart-skeleton-legend">
        <div className="ec-chart-skeleton-legend-item"></div>
        <div className="ec-chart-skeleton-legend-item"></div>
        <div className="ec-chart-skeleton-legend-item"></div>
      </div>
    </div>
  );
}
